import { CategoryListProps } from '@engyalo/delivery-ui-components/lib/ui/components/CategoryList'
import { DefaultProps } from '../../../interfaces'
import {
  CinnamonActionNames,
  CinnamonPaths,
  TemplateActionNames,
} from '../defaultConstants'

export const CategoryListDefault: DefaultProps<CategoryListProps> = {
  categories: '{{catalog.categoryList}}' as any,
  loading: '{{catalog.isFetchingMore}}' as any,
  clickActions: {
    cinnamonActions: [
      {
        name: TemplateActionNames.FILTERS_CLEAR_FILTERS,
        args: {},
      },
      {
        name: CinnamonActionNames.PUSH_VIEW,
        args: {
          path: `${CinnamonPaths.CATEGORIES}/{{this.category.slug}}`,
          category: '{{catalog.categoryList}}',
        },
      },
    ],
  } as any,
  reachBottomActions: {
    cinnamonActions: [
      {
        name: TemplateActionNames.CATEGORIES_FETCH,
      },
    ],
  } as any,
}
